var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTechqillalogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 97,
    height: 119,
    viewBox: "0 0 97 119",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 33.7L96.6 0L20.6 68.5L0 33.7Z",
    fill: "url(#paint0_linear_1289_312)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.9004 68.4998L65.5004 34.2998L48.3004 119L34.9004 68.4998Z",
    fill: "url(#paint1_linear_1289_312)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M48.3004 119L46.4004 72.8998L65.5004 34.2998L48.3004 119Z",
    fill: "url(#paint2_linear_1289_312)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M91.9006 66.7004L77.8006 22.9004L59.1006 107.4L91.9006 66.7004Z",
    fill: "url(#paint3_linear_1289_312)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M59.1006 107.4L79.6006 66.0004L77.8006 22.9004L59.1006 107.4Z",
    fill: "url(#paint4_linear_1289_312)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6006 68.5L22.9006 44.7L96.6006 0L20.6006 68.5Z",
    fill: "url(#paint5_linear_1289_312)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M76.1004 95.7002L92.3004 116.4L69.4004 103.6L76.1004 95.7002Z",
    fill: "url(#paint6_linear_1289_312)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M69.4004 103.6L75.4004 102.2L92.3004 116.4L69.4004 103.6Z",
    fill: "url(#paint7_linear_1289_312)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1289_312",
    x1: 35.4121,
    y1: 72.0068,
    x2: 54.5809,
    y2: -9.8383,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8D19DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#901AD8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#9A1CD3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#AA20C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#C126BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#DF2DAB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED30A3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1289_312",
    x1: 34.9404,
    y1: 76.6448,
    x2: 65.4704,
    y2: 76.6448,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8D19DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#901AD8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#9A1CD3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#AA20C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#C126BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#DF2DAB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED30A3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1289_312",
    x1: 46.4104,
    y1: 76.6448,
    x2: 65.4704,
    y2: 76.6448,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED30A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#8D19DA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1289_312",
    x1: 59.1306,
    y1: 65.1454,
    x2: 91.8506,
    y2: 65.1454,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED30A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#8D19DA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1289_312",
    x1: 59.1306,
    y1: 65.1454,
    x2: 79.5906,
    y2: 65.1454,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8D19DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#901AD8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#9A1CD3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#AA20C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#C126BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#DF2DAB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED30A3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1289_312",
    x1: 20.6106,
    y1: 34.275,
    x2: 96.6206,
    y2: 34.275,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED30A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#8D19DA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1289_312",
    x1: 71.431,
    y1: 104.565,
    x2: 94.261,
    y2: 107.185,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED30A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#8D19DA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1289_312",
    x1: 78.2499,
    y1: 103.79,
    x2: 84.8699,
    y2: 119.56,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8D19DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#901AD8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#9A1CD3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#AA20C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#C126BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#DF2DAB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED30A3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTechqillalogo);
export default __webpack_public_path__ + "static/media/techqillalogo.437da6457d49df882df8537fe53675c4.svg";
export { ForwardRef as ReactComponent };